<template>
  <div>
    <section class="main-content">
      <!--
      <div class="inner-banner inner-banner-bg">
          <div class="container">
              <div class="articles-box">
                  <figure class="pic articles-pic fitimg mb-0">
                      <img class="img-fluid" src="https://admin.weddingsung.com/upload/slide/88311b59e2e2c107d44366e24d81f644.png" />
                  </figure>
              </div>
          </div>
      </div>
      -->
        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="bck-index bck-articles">
                            <h3 class="title"><span>熱門話題</span></h3>
                            <div class="articles-items">

                                <div class="row">

                                    <div class="col-xl-3 col-lg-4 col-md-6"  v-for="(row, index) in hot">
                                        <div class="articles-box news-box">
                                            <a :href="row.link" target="_blink">
                                                <figure class="pic articles-pic fitimg mb-0">
                                                    <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/hot/'+row.image_path" />
                                                </figure>
                                                <div class="text text-center">
                                                    <h5 class="title text-primary">{{row.title}}</h5>
                                                    <p class="txt mb-0" v-html="row.context"></p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'hot',
  data () {
    return {
      uri: this.$store.getters.getUri,
      hot: Object
    }
  },
  computed: {
    ...mapGetters([
      'getUri'
    ])
  },
  mounted: function () {
    let self = this
    this.$http.get(this.uri + 'hot/getHot').then(function (res) {
      let data = res.data
      if (data.status === 200) {
        self.hot = data.hots
      } else {
        console.log('下載熱門話題失敗')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Hot.vue?9974df44